// Shared RoboForex account-opening walkthrough data.
// Single source of truth for BOTH the customer onboarding page
// (`Onboarding.jsx`) AND the partner onboarding accordion
// ("Noch kein RoboForex-Konto?" — `PartnerOnboarding.jsx`).
// Keep edits here so both flows stay in sync.

export const RF_VIDEO_ID = "HkR691IptDs";
export const RF_REGISTER_LINK = "https://my.roboforex.com/";
export const RF_WHATSAPP_CHANNEL = "https://chat.whatsapp.com/JswcwPx6YhgAmVRLMokYRH";

export const RF_STEPS = [
  {
    text: "Registrierungslink öffnen und auf „Register\" klicken",
    cta: { label: "Registrierungslink öffnen", href: RF_REGISTER_LINK },
  },
  "Partner-ID der empfehlenden Person eingeben",
  "E-Mail, Vorname, Nachname und Telefonnummer eingeben & E-Mail-Adresse bestätigen",
  "Zwei-Faktor-Authentifizierung aktivieren (Google Authenticator)",
  "KYC durchführen",
  "Auf Verifizierungsbestätigung warten",
  {
    text: "WhatsApp Community beitreten",
    cta: { label: "WhatsApp Community beitreten", href: RF_WHATSAPP_CHANNEL },
  },
];
